export default "__VITE_ASSET__CQEat$Id__"